export const Archivements = [
  {
    year: "Dec 2025",
    title: "Codeclash - The Conclave",
    description: "Secured 1st Rank",
  },
  {
    year: "Nov 2025",
    title: "Code Jam - siNUsoid (NIIT University)",
    description: "Secured 6th Rank",
    link: "https://www.hackerrank.com/contests/code-jam-sinusoid-v9/leaderboard",
  },
  {
    year: "Nov 2025",
    title: "Code Mahotsav 2.0",
    description: "Secured 2nd Rank",
    link: "https://unstop.com/hackathons/code-mahotsav-2o-pranveer-singh-institute-of-technologypsitkanpur-1579456/online-assessment/377392",
  },
  {
    year: "Aug 2025",
    title: "Codeclash - August Conclave",
    description: "Under top 10 Rank",
    link: "https://unstop.com/hackathons/codeclash-the-august-arena-lets-code-community-1513765/online-assessment/355195",
  },
  {
    year: "Aug 2025",
    title: "Vuencode Hackhathon",
    description: "Secured 3rd Rank",
    link: "",
  },
  {
    year: "Oct 2024",
    title: "Amazon ML Challenge",
    description: "Secured rank 523th Globally",
    link: "",
  },
  {
    year: "Sep 2024",
    title: "NLP with Disaster Tweets Competition",
    description: "Secured 319th Rank Globally",
    link: "",
  },
  {
    year: "Mar 2024",
    title: "HackANDChill Hackhathon",
    description: "Mentor at the event.",
    link: "",
  },
  {
    year: "Mar 2024",
    title: "GDSC ADGIPS",
    description: "Invited as the Guest Speaker for the event.",
    link: "",
  },
  {
    year: "Feb 2024",
    title: "Google Solution Challenge",
    description: "Semi-Finalist in Google Solution Challenge",
    link: "",
  },
  {
    year: "Aug 2023",
    title: "Code Gladiators by Techgig",
    description: "Achieved Rank 316 Globally",
    link: "",
  },
  {
    year: "Mar 2023",
    title: "Hack36.6 MNNIT Hackathon",
    description: "Achieved 3rd Rank Internationally",
    link: "https://drive.google.com/file/d/1cZbles8GYNQYAu126BNv6Q8LodQYS_Nr/view",
  },
  {
    year: "Mar 2023",
    title: "Reply Coding Challenge",
    description: "Achieved rank 578 Internationally",
    link: "https://drive.google.com/file/d/1jRBxNY0OFlTN7UCyJTvd0qCiIiOxYWLu/view",
  },
  {
    year: "Jan 2023",
    title: "Shebuilds Hackathon",
    description: "Achieved Overall 1st position Nationaly.",
    link: "https://drive.google.com/file/d/156FbqmlCulWK1g6LhwBU_0ytL9T-Hm8r/view",
  },
  {
    year: "Feb 2023",
    title: "HackNITR (NIT Rourkela) Hackathon",
    description: "2nd Runner’s up at HackNITR Hackathon.",
    link: "https://drive.google.com/file/d/1c5cbP25MKalei_QsxCORd6-7pCM6icvl/view",
  },
  {
    year: "Sep 2022",
    title: "Hack the mountains 3.0",
    description: "Achieved 3rd Rank Internationally.",
    link: "https://drive.google.com/file/d/1cTxNKRsZZ8wdNvIIhQ1O39DjonO2KzHH/view",
  },
  {
    year: "Sep 2022",
    title: "WECODE by Graphic Era Hill University",
    description: "Achieved Rank 3",
    link: "https://drive.google.com/file/d/1DUWw3Xpm495K0iDSY2S-DnWpTXR9lwSa/view",
  },
  {
    year: "Mar 2022",
    title: "CODING NINJA CODEKAZE",
    description: "Achieved Rank 1 Institute Rank & Rank 554 All India",
    link: "https://drive.google.com/file/d/1DUWw3Xpm495K0iDSY2S-DnWpTXR9lwSa/view",
  },
  {
    year: "Nov 2021",
    title: "CODECHEF SNACKDOWN",
    description: "Achieved Rank Under Top 500 Globally",
    link: "https://www.codechef.com/certificates/public/87607ed",
  },
];
